import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

import { LogoConfig } from "@/types";
import { useClient } from "@/hooks";
import { useDemo } from "@/context";

let clientComponentMap: Record<string, React.ComponentType<any>> = {};

export function getClientComponent<TProps>(
  name: string,
  fallback: React.ComponentType<TProps>
): React.ComponentType<TProps> {
  return (clientComponentMap[name] as React.ComponentType<TProps>) || fallback;
}

// type ClientComponentProps<TProps> = {
//   name: string;
//   fallback: React.ComponentType<TProps>;
// } & TProps;
//
// export function ClientComponent<TProps>(props: ClientComponentProps<TProps>): JSX.Element {
//   const { name, fallback, ...rest } = props;
//   const Component = getClientComponent<TProps>(name, fallback);
//   return React.createElement(Component, rest as TProps) as JSX.Element;
//   // return <Component {...(rest as TProps)} />;
// }

export async function preloadClientComponents() {
  const client = process.env.REACT_APP_CLIENT;

  if (!client) return;

  try {
    const { componentMap } = await import((`@/components/client/${client}/componentMap`));
    clientComponentMap = componentMap;
  } catch {
    clientComponentMap = {};
  }
};

export const defaultLogo = <Typography
  variant="h1"
  sx={{
    textAlign: "center",
    fontFamily: "cera-pro-bold",
  }}
>
  —CONNECT—
</Typography>

export const useLogo = () => {
  const [config, setConfig] = useState<LogoConfig | null>(null);
  const client = useClient();
  const { demoClient } = useDemo();

  useEffect(() => {

    const load = async () => {
      const pathParts = [client, demoClient].filter(Boolean);
      const configModule = await import (`@/assets/logos/${pathParts.join('/')}/config`);
      setConfig(configModule.logoConfig);
    };

    load();
  }, [client, demoClient]);

  return config;
};

export const useConnectLogo = (mode: string) => {

  const [logo, setLogo] = useState<React.ComponentType | null>(null);
  const [logoSize, setLogoSize] = useState<number>(720);
  const client = useClient();
  const { demoClient } = useDemo()

  const defaultLogo = () => (
    <Typography
      variant="h1"
      sx={{
        textAlign: "center",
        fontFamily: "cera-pro-bold",
      }}
    >
      —CONNECT—
    </Typography>
  );

  useEffect(() => {

    const load = async () => {
      try {
        const pathParts = [client, demoClient].filter(Boolean);
        const logoModule = await import (`@/assets/logos/${pathParts.join('/')}/ConnectLogo`);
        setLogo(() => logoModule.default);
      } catch (err) {
        if (client !== 'core' && client !== 'demo') {
          if (mode === 'dark') {
            const logoModule = await import(`@/assets/logos/${client}/Logo`);
            setLogo(() => logoModule.default);
          } else {
            const logoModule = await import(`@/assets/logos/${client}/LogoDark`);
            setLogo(() => logoModule.default);
          }
        } else {
          setLogo(() => defaultLogo);
        }
      }

      try {
        const pathParts = [client, demoClient].filter(Boolean);
        const configModule = await import (`@/assets/logos/${pathParts.join('/')}/config`);
        setLogoSize(configModule.logoConfig.home.width)
      } catch (err) {
        setLogoSize(720);
      }
    };

    load();

  }, [mode, client, demoClient]);

  return { Logo: logo, logoSize };
};

export const getPageConfig = () => {
  const client = process.env.REACT_APP_CLIENT || "core";

  console.log('CLIENT', client);

  if (client === "gravity") {
    return {
      title: "Gravity Connect"
    }
  } else if (client === 'miroma') {
    return {
      title: "Miroma Prism"
    }
  } else if (client === 'demo') {
    return {
      title: "Demo Connect"
    }
  } else {
    return {
      title: "CONNECT"
    };
  }

};
